<template>
	<div>
		<div class="row">
			<div class="col-md-4">
				Message List:
				
				<select name="" id="" class="form-select" v-model="rule.settings.message_list_id">
					<option :value="null">- Select an option -</option>
					<option :key="list.id" v-for="list in messageLists" :value="list.id">{{list.name}}</option>
				</select>
				<br />
				
				Delivery Methods:
				<div id="deliverMethods" class="checkbox" style="margin:5px 0 10px 0; padding-top:0px;">
					<label style="margin:0;">
						<input type="checkbox" value="1" v-model="rule.settings.send_email"> Email<br/>
						<input type="checkbox" value="1" v-model="rule.settings.send_text"> Text message<br/>
						<input type="checkbox" value="1" v-model="rule.settings.send_feed"> Feed<br/>
					</label>
				</div>
				
				<input
					type="text"
					class="redemptionSubject form-control"
					placeholder="Subject..."
					v-model="rule.settings.subject"
				/>
				<br />
				<select class="input-small form-control mb-2" v-model="rule.settings.message">
					<option disabled selected value="">Please select a preset</option>
					<option :key="preset.name" :value="preset.value" v-for="preset in total_redemption_presets">{{preset.name}}</option> 
				</select>
				<textarea
					class="redemptionMessage form-control"
					placeholder="Message..."
					v-model="rule.settings.message"
				></textarea>
			</div>
			<div class="col-md-4">
				Total Redemptions:
				<br />
				<input
					type="number"
					class="redemptionsNeeded form-control"
					min="1"
					v-model.number="rule.settings.redemptions_needed"
				/><br/>
				
				From Only These: (not required)
				<br />
				<multiselect
					v-model="productOptions"
					:options="filteredProducts"
					:close-on-select="false"
					:hide-selected="true"
					multiple
					track-by="id"
					label="name"
					group-values="options"
					group-label="group_name"
					:internal-search="false"
					@search-change="doSearch"
				>
					<template slot="tag" slot-scope="props">
						<span class="multiselect__tag" :title="props.option.name">
							<small class="multiselect__tag-small">{{ props.option.venueName }}</small>
							<p class="multiselect__tag-text">{{ props.option.name }}</p>
							<i aria-hidden="true" tabindex="1" @click="props.remove(props.option)" class="multiselect__tag-icon"></i>
						</span>
					</template>
				</multiselect><br/>
				
				Redemptions Made After:<br/>
				<date-picker v-model="startDate"></date-picker><br/>
				
				Redemptions Made Before:<br/>
				<date-picker v-model="endDate"></date-picker><br/>
				
				<div class="checkbox">
					<label>
						<input type="checkbox" class="onePerVenue" v-model="rule.settings.one_per_venue" />
						Only count one redemption per venue
					</label>
				</div>
			</div>
			<div class="col-md-4">
				Max Sends:
				<br />
				<select class="maxSends input-small form-control" v-model.number="rule.settings.max_sends">
					<option value="1000">--</option>
					<option v-for="maxSends in 10" :value="maxSends" :key="maxSends">{{ maxSends }}</option>
				</select><br/>
				
				Min Frequency:
				<div class="row">
					<div class="col-md-5">
						<select class="minFrequency input-small form-control" v-model.number="rule.settings.min_frequency">
							<option value="0">--</option>
							<option
								v-for="minFrequency in 365"
								:value="minFrequency"
								:key="minFrequency"
							>{{ minFrequency }}</option>
						</select>
					</div>
					<div class="col-md-7" v-if="rule.settings.min_frequency>0">
						<select
							class="minFrequencyType input-small form-control"
							v-model="rule.settings.min_frequency_type"
						>
							<option v-for="type in types" :value="type" :key="type">{{ type }}</option>
						</select>
					</div>
				</div><br/>
				
				Send Delay:
				<div class="row">
					<div class="col-md-5">
						<select class="delay input-small form-control" v-model.number="rule.settings.delay">
							<option value="0">--</option>
							<option v-for="delay in 365" :value="delay" :key="delay">{{ delay }}</option>
						</select>
					</div>
					<div class="col-md-7" v-if="rule.settings.delay>0">
						<select class="delayType input-small form-control" v-model="rule.settings.delay_type">
							<option v-for="type in types" :value="type" :key="type">{{ type }}</option>
						</select>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			rule: {
				type: Object,
				required: true,
			},
			products: {
				type: Array,
				required: true,
			},
			messageLists: {
				type: Array,
				default() {
					return []
				}
			}
		},
		data() {
			return {
				types: ["years", "months", "days", "hours", "minutes"],
				total_redemption_presets: [
					{ name: "Prize", value: 'https://explore.discoverclermont.com/dogtag?promoCode={{autoPromoCode|2126}} - Congratulations! You have won a free dog tag. To redeem your prize, click on the link above. Your prize will be mailed to you within 4-6 weeks.' }
				],
				localProducts: null,
			};
		},
		computed: {
			filteredProducts: {
				get() {
					return this.localProducts === null ? this.products : this.localProducts;
				},
				set(v) {
					this.localProducts = v;
				}
			},
			startDate: {
				get() {
					return Bandwango.dateToLocal(this.rule.settings.start_date_time);
				},
				set(v) {
					this.$set(this.rule.settings, 'start_date_time', Bandwango.dateToUtc(v));
				}
			},
			endDate: {
				get() {
					return Bandwango.dateToLocal(this.rule.settings.end_date_time);
				},
				set(v) {
					this.$set(this.rule.settings, 'end_date_time', Bandwango.dateToUtc(v));
				}
			},
			productIds: {
				get() {
					let values = [];
					this.products.forEach((group) => {
						let filtered = group.options.filter((option) => {
							return this.rule.settings.product_ids.map(Number).indexOf(option.id) > -1; 
						});
						if (filtered.length > 0) values = values.concat(filtered);
					});
					return values;
				},
				set(newVal) {
					this.rule.settings.product_ids = newVal.map((v) => v.id);
				}
			},
			productOptions: {
				get() {
					let values = [];
					this.products.forEach((group) => {
						let filtered = group.options.filter((option) => {
							return this.rule.settings.product_options.map(Number).indexOf(option.id) > -1; 
						});
						if (filtered.length > 0) values = values.concat(filtered);
					});
					return values;
				},
				set(newVal) {
					this.rule.settings.product_options = newVal.map((v) => v.id);
				}
			},
		},
		methods: {
			doSearch(query) {
				if (query === '') this.filteredProducts = this.products;
				else {
					const options = {
						ignoreFieldNorm: true,
						ignoreLocation: true,
						threshold: 0.0,
						keys: ['group_name', 'options.name', 'options.categories.name']
					}
					const fuse = new Fuse(this.products, options);
					this.filteredProducts = fuse.search(query).map(res => res.item);
				}
			},
		},
		mounted() {
			let vm = this;
	
			Vue.nextTick(() => {
				// setup defaults
				vm.rule.settings = _.extend(
					{
						max_sends: 1,
						delay: 1,
						delay_type: "minutes",
						min_frequency: 0,
						min_frequency_type: "days",
						send_email: 1,
						send_text: 1,
						send_feed: 1
					},
					vm.rule.settings
				);
				vm.$forceUpdate();
			});
		},
	};
</script>